var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "logo__container" }, [
    _c("img", {
      staticClass: "logo__client",
      attrs: { src: _vm.cwa_logo_src, alt: "QPESUMS第二代" }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "logo__cwa",
      attrs: { src: "/static/images/header/cwa-logo.png", alt: "中央氣象署" }
    }),
    _vm._v(" "),
    _vm.show_custom && _vm.is_custom_logo_exist
      ? _c("div", { staticClass: "logo__customization" }, [
          _c("div", { staticClass: "logo__customization-divider" }),
          _vm._v(" "),
          _c("img", {
            staticClass: "logo__customization-img",
            attrs: {
              src: _vm.get_src(_vm.custom_logo),
              alt: "客製化版本logo",
              contain: ""
            },
            on: {
              error: function($event) {
                return _vm.change_src()
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }